import { render, staticRenderFns } from "./ModalAddProduct.vue?vue&type=template&id=ac658648&scoped=true"
import script from "./ModalAddProduct.vue?vue&type=script&lang=js"
export * from "./ModalAddProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProduct.vue?vue&type=style&index=0&id=ac658648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac658648",
  null
  
)

export default component.exports